import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  bgColor: "#075485",
  cardColor: "#22272B",
  boardColor: "#101204",
  textColor: "#B6C2CF",
};
